/**
 * SiteHeaderV2 — réexport du header public unique.
 *
 * Ce fichier portait une SECONDE barre de nav, montée par la home et
 * /plans : mêmes cinq entrées, mais sans sélecteur de langue, avec ses
 * propres libellés figés en français et son propre comportement de
 * position (`fixed`, d'où les 148/150px réservés en haut de ces pages).
 * Deux barres à maintenir, c'est une barre qui dérive.
 *
 * Il ne reste que le réexport, pour ne casser aucun import existant. Le
 * fichier n'est pas supprimé : c'est un point d'entrée public du dossier
 * `siteV2`, et le supprimer ferait échouer un import qu'on n'aurait pas
 * vu passer.
 *
 * `SITE_HEADER_HEIGHT` reste exporté — l'en-tête collant de la matrice de
 * /plans s'en sert pour se caler SOUS la barre. La valeur suit désormais
 * le header unique, qui est `position: sticky` (header-v2.css) et non
 * plus `fixed` : les pages n'ont plus à réserver sa hauteur, elle est
 * dans le flux.
 */
export { default } from '../PublicHeader';

/**
 * Hauteur rendue du header, en px — MESURÉE au rendu (Playwright,
 * getBoundingClientRect), pas estimée : 65px au-dessus de 820px de large.
 * Arrondie au pixel supérieur pour que ce qui se colle dessous passe
 * SOUS la bordure : le fond de la barre est translucide, un demi-pixel de
 * débord laisserait voir le contenu défiler au travers.
 */
export const SITE_HEADER_HEIGHT = 66;
